/// <amd-module name="Work/Views/MyWork/DataProviders/MyWorkMyActivityProvider" />
import { IVssPageContext } from "VSS/Platform/Context";

import * as ContributionRoutes from "../Constants/ContributionRoutes";
import { WorkItem, AccountRecentActivityWorkItemModel2 } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { IWorkItemTrackingRestClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking.Types";
import { IMyWorkProvider, FormattedDate } from "DataProviders/IMyWorkProvider";
import { MyWorkProviderBase, activityDateFieldName } from "DataProviders/MyWorkProviderBase";
import { routeUrl } from "VSS/Platform/Location";
import { format } from "VSS/Core/Util/String";
import { ago } from "VSSUI/Utilities/Date";
import * as MyWorkResources from "Work/Views/MyWork/Resources";

/**
 * Data provider to retrieve data for the 'My Activity' section.
 */
export class MyWorkMyActivityProvider extends MyWorkProviderBase<AccountRecentActivityWorkItemModel2[]> implements IMyWorkProvider {
    private displayItems: WorkItem[] = [];

    constructor(context: IVssPageContext) {
        super(context);
    }

    public getLimitExceeded(): boolean {
        return super.getLimitExceeded();
    }

    public getWorkItems(): WorkItem[] {
        return this.displayItems;
    }

    protected getData(): Promise<AccountRecentActivityWorkItemModel2[]> {
        const client = this.context.getRestClient<IWorkItemTrackingRestClient>("IWorkItemTrackingRestClient");
        const promise = client.getRecentActivityData();

        promise.then((results: AccountRecentActivityWorkItemModel2[]) => {
            this.setDisplayWorkItems(results);
        });

        return promise;
    }

    protected getDataLength(): number {
        if (this.queryResult) {
            return this.queryResult.length;
        }

        return 0;
    }

    private setDisplayWorkItems(workItems: AccountRecentActivityWorkItemModel2[]): void {
        this.displayItems = workItems.map(item => {
            const projectName = item.teamProject;
            const id = item.id;
            const workItemEditUrl = projectName
                ? routeUrl(this.context, ContributionRoutes.WorkItemRoute, {
                      project: projectName,
                      id: `${id}`
                  })
                : "";
            const projectUrl = projectName ? routeUrl(this.context, ContributionRoutes.ProjectRoute, { project: projectName }) : "";
            const customLastUpdatedDate = format(MyWorkResources.LastUpdatedDateFormat, ago(item.changedDate));
            const formattedDate: FormattedDate = {
                date: item.changedDate,
                formattedDate: customLastUpdatedDate
            };

            return ({
                fields: {
                    [CoreFieldRefNames.AssignedTo]: item.assignedTo,
                    [CoreFieldRefNames.State]: item.state,
                    [CoreFieldRefNames.TeamProject]: item.teamProject,
                    [CoreFieldRefNames.Title]: item.title,
                    [CoreFieldRefNames.WorkItemType]: item.workItemType,
                    [activityDateFieldName]: formattedDate
                },
                id: id,
                _links: {
                    html: workItemEditUrl,
                    project: projectUrl
                }
            } as unknown) as WorkItem;
        });
    }
}
